import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'accountNumber' })
export class AccountNumberPipe implements PipeTransform {
  public transform(value: string, _args?: boolean): string {
    if (value !== '' && value !== undefined && value !== null) {
      const length: number = value.length;
      return 'x'.repeat(length - 3).concat(value.substr(length - 3));
    }
  }
}
